import { Helmet } from "react-helmet";
import { CANNONICAL_URL } from "../../../constants";
import { useLocation } from "react-router-dom";
import { PropsWithChildren, useContext } from "react";
import MessageContext from "../../../utils/messages/message-context";

export function Title({ children }: PropsWithChildren) {
    const location = useLocation();
    const messages = useContext(MessageContext);

    return (
        <Helmet>
            <title>{children} - {messages.SITE_TITLE}</title>
            <link rel="canonical" href={`${CANNONICAL_URL}${location.pathname}`}/>
        </Helmet>
    );
}